module.exports = __webpack_public_path__ + "static/media/FinkHeavyRegular.e8a8b570.woff2";